export const hubElementPlaceholderExtensionType =
	'com.atlassian.confluence.hub-element-placeholder';
